class CustomerAdminUsers {
  static Customer_Admin_Users_Endpoints = {
    list: 'companies/users',
    getUserId: 'companies/users/',
    getCountForAllNonRegisterUsers: 'personnel/employees/users/non-register/count',
    bulkCreateUsers: 'companies/users/bulk',
    bulkCreateUsersValidate: 'companies/batch/process/users/creation/validate',
    bulkCreateUsersProcessValidate: '/companies/batch/process/visibility',
  }
}

export default CustomerAdminUsers
